const imagePath = '../assets/';
const configImages = {
  defaultImg: require(`../assets/img/profile/defaultImg.png`),
  defaultUserImage: require(`../assets/img/profile/default_user_image.png`),
  employeesSampleXL: require(`../assets/files/scheduleSampleUpload.xlsx`),
  loginImage: require(`../assets/img/logo/default_project_logo.png`),
  loginSideImage: require(`../assets/img/logo/default_LoginSideImage.webp`),
  // loginLogo: require(`../assets/img/logo/loginLogo.jpg`),
  loaderImage: require(`../assets/loader.gif`)

};
export default configImages;
